import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';
import { PopupFooter } from '@gem/ui-kit';

import { ForwardMessageFooterView } from 'APP/main/PopupManager/components/ForwardMessageFooterView/ForwardMessageFooterView';
import { ShareDataView } from 'APP/main/PopupManager/components/ShareDataView/ShareDataView';

import {
  IForwardMessageWithInfoPopupParams,
  useForwardMessageWithInfoPresenter,
} from './ForwardMessageWithInfoPopup.presenter';
import styles from './ForwardMessageWithInfoPopup.styles.m.css';

export const ForwardMessageWithInfoPopup: FC<
  ICommonPopupsProps<IForwardMessageWithInfoPopupParams>
> = observer((props) => {
  const presenter = useForwardMessageWithInfoPresenter(props);
  useClosePopupOnNavigation(props.popupInstance);

  return (
    <Popup
      isOpened
      title={props.params?.title}
      onClose={presenter.onClose}
    >
      <ShareDataView
        multiselect
        onSelectItem={presenter.onSelectItem}
        onChangeSelection={presenter.onChangeSelection}
      />
      <PopupFooter
        className={classNames(styles.forwardMessageFooter, {
          [styles.withInput]: !!presenter.selection.length,
        })}
      >
        <ForwardMessageFooterView
          selection={presenter.selection}
          isDisabled={!presenter.hasSelected}
          isLoading={presenter.isSubmitting}
          onSubmit={presenter.submit}
        />
      </PopupFooter>
    </Popup>
  );
});
